export default "__VITE_ASSET__DQXynsqn__"